import { render, staticRenderFns } from "./CreateOrEditSportSubscriptionPlan.vue?vue&type=template&id=35ca68eb&scoped=true"
import script from "./CreateOrEditSportSubscriptionPlan.vue?vue&type=script&lang=js"
export * from "./CreateOrEditSportSubscriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./CreateOrEditSportSubscriptionPlan.vue?vue&type=style&index=0&id=35ca68eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ca68eb",
  null
  
)

export default component.exports